import { render, staticRenderFns } from "./StaticField.vue?vue&type=template&id=6b7ae7a2&"
import script from "./StaticField.vue?vue&type=script&lang=js&"
export * from "./StaticField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports